export enum EERRORS {
  ERROR_500 = "خطا در اتصال به سرور"
}

